/**
 * Droppable Day Cell Component
 * Used in month calendar view for drag-and-drop
 */
import { useDroppable } from "@dnd-kit/core";
import { format } from "date-fns";

export const DroppableDay = ({ day, children, isToday, isSelected, isCurrentMonth = true, onDayClick, onDoubleClick }) => {
  const dateStr = day ? format(day, "yyyy-MM-dd") : null;
  const { isOver, setNodeRef } = useDroppable({
    id: dateStr || "empty-cell",
    data: { date: day },
    disabled: !day
  });

  return (
    <div
      ref={setNodeRef}
      className={`min-h-[100px] p-2 border-b border-r border-slate-100 transition-colors ${
        !day ? 'bg-slate-50' : isCurrentMonth ? 'hover:bg-slate-50 cursor-pointer' : 'bg-slate-50/50 hover:bg-slate-100/50 cursor-pointer'
      } ${isSelected ? 'bg-blue-50' : ''} ${isOver && day ? 'bg-blue-100 ring-2 ring-blue-400 ring-inset' : ''}`}
      onClick={() => day && onDayClick(day)}
      onDoubleClick={() => day && onDoubleClick(day)}
    >
      {day && (
        <>
          <div className={`text-sm mb-1 ${
            isToday 
              ? 'w-7 h-7 bg-slate-900 text-white rounded-full flex items-center justify-center' 
              : isCurrentMonth ? 'text-slate-600' : 'text-slate-400'
          }`}>
            {format(day, "d")}
          </div>
          <div className="space-y-1">
            {children}
          </div>
        </>
      )}
    </div>
  );
};

export default DroppableDay;
